(() => {
  'use strict';
  if (Number(window.Shopify?.theme?.id) !== 186999570810) return;

  const selector = '#_rsi-cod-form-embed ._rsi-modal-fields-item._rsi-modal-fields-item-with-icon input';
  let queued = false;

  function installAutofillStyle() {
    if (document.getElementById('amr-autofill-field-style')) return;
    const style = document.createElement('style');
    style.id = 'amr-autofill-field-style';
    style.textContent = `
      #_rsi-cod-form-embed ._rsi-modal-fields-item-with-icon input:-webkit-autofill,
      #_rsi-cod-form-embed ._rsi-modal-fields-item-with-icon input:-webkit-autofill:hover,
      #_rsi-cod-form-embed ._rsi-modal-fields-item-with-icon input:-webkit-autofill:focus {
        -webkit-text-fill-color: #111 !important;
        caret-color: #111 !important;
        -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
        box-shadow: 0 0 0 1000px #fff inset !important;
      }
      #_rsi-cod-form-embed ._rsi-modal-fields-item-with-icon[data-amr-autofill-icon-fixed='overlay']::after {
        content: '';
        position: absolute;
        display: block;
        width: 44px;
        height: var(--amr-autofill-icon-height);
        left: var(--amr-autofill-icon-left);
        top: var(--amr-autofill-icon-top);
        pointer-events: none;
        z-index: 2;
        background-image: var(--amr-autofill-icon-image);
        background-repeat: no-repeat;
        background-position: 0 50%;
        background-size: 44px auto;
      }
    `;
    document.head.appendChild(style);
  }

  function iconFromReleasitRules(input) {
    const sheet = document.querySelector('#rsi-icons-css')?.sheet;
    if (!sheet) return '';
    let icon = '';
    try {
      for (const rule of sheet.cssRules) {
        if (!rule.selectorText || !rule.style?.backgroundImage) continue;
        const matches = rule.selectorText.split(',').some(part => {
          try { return input.matches(part.trim()); } catch (_) { return false; }
        });
        if (matches) icon = rule.style.backgroundImage;
      }
    } catch (_) { /* Releasit may still be replacing its generated icon sheet. */ }
    return icon;
  }

  function fixIcon(input) {
    const icon = iconFromReleasitRules(input);
    if (!icon) return;

    const field = input.closest('._rsi-modal-fields-item-with-icon');
    if (!field) return;
    const rtl = Boolean(input.closest('._rsi-modal-container-rtl'));
    const customDesign = Boolean(input.closest('#_rsi-cod-form-embed.amr-cod-design'));
    const compact = customDesign && matchMedia('(max-width: 380px)').matches;
    const padding = customDesign ? (compact ? '32px' : '37px') : '59px';

    field.querySelectorAll(':scope > .amr-autofill-icon').forEach(node => node.remove());
    if (getComputedStyle(field).position === 'static') field.style.position = 'relative';
    field.style.setProperty('--amr-autofill-icon-image', icon);
    field.style.setProperty('--amr-autofill-icon-top', `${input.offsetTop}px`);
    field.style.setProperty('--amr-autofill-icon-height', `${input.offsetHeight}px`);
    field.style.setProperty(
      '--amr-autofill-icon-left',
      rtl ? `${input.offsetLeft + input.offsetWidth - 44}px` : `${input.offsetLeft}px`
    );
    field.setAttribute('data-amr-autofill-icon-fixed', 'overlay');

    input.style.setProperty('background-image', 'none', 'important');
    if (rtl) input.style.setProperty('padding-right', padding, 'important');
    else input.style.setProperty('padding-left', padding, 'important');
    input.setAttribute('data-amr-autofill-icon-fixed', 'overlay');
  }

  function scan() {
    queued = false;
    installAutofillStyle();
    document.querySelectorAll(selector).forEach(fixIcon);
  }

  function queueScan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(scan);
  }

  new MutationObserver(queueScan).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
  ['input', 'change', 'focusin'].forEach(type => document.addEventListener(type, event => {
    if (event.target.matches?.(selector)) requestAnimationFrame(() => fixIcon(event.target));
  }, true));
  window.addEventListener('resize', queueScan, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queueScan, { once: true });
  else queueScan();
  [250, 750, 1500, 3000].forEach(delay => setTimeout(scan, delay));
})();